<template>
  <div>
    <ul class="hotlist">
      <li>
        <span>提高效率</span>
        <span>提升效能</span>
        <span>提增效益</span>
        <span class="hot">HOT</span>
      </li>
      <li>
        <span>教育培训</span>
        <span>国家省委办实事</span>
      </li>
      <li>
        <span>深入贯彻党的教育</span>
        <span class="hot">HOT</span>
      </li>
      <li>
        <span>教育培训</span>
        <span>搞实事</span>
        <span class="hot">HOT</span>
      </li>
    </ul>
  </div>
</template>

<script>

export default {
  name: "HotList",
  components: {
  },
  data() {
    return {

    }
  },
  mounted() {
  },
  methods: {}
};
</script>
<style scoped>
.hotlist {
  position: relative;
  margin-top: 26px;
  width: 1200px;
  height: 80px;
  display: flex;
  justify-content: space-between;
}

.hotlist>li {
  position: relative;
  width: 288px;
  height: 100%;
  background: url(/static/img/img_1.png) no-repeat 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #1759A1;
  line-height: 16px;
}

.hotlist>li>span {
  text-align: center;
  padding: 0 8px;
}

.hotlist>li>span.hot {
  position: absolute;
  top: 10px;
  right: 9px;
  padding: 0;
  text-align: center;
  width: 41px;
  height: 17px;
  background: #BB1414;
  border-radius: 0px 9px 0px 9px;
  font-size: 14px;
  font-family: PingFang SC;
  font-weight: bold;
  color: #FFFFFF;
  line-height: 17px;
}
</style>
